/**
 * @description 图文
*/
import React, { useState, useRef, useEffect } from "react";
import JsBridge from 'library/jsbridge';
import {ListView} from "components";
import { Slogon } from '../../../../slogon';
import styles from './index.module.scss';
import { useHistory } from 'react-router-dom';

import extraImage1 from '../../../../../member/family/hotInformation/images/extraImage4.png';

export const ImgTxtList = (props) => {
    
    const {list=[], hasMore, onRefresh, loadMore} = props;
    const history = useHistory();
    const [loadedImages, setLoadedImages] = useState(new Set());
    const [retryCount, setRetryCount] = useState({});

    const getImage = (url) => {
        if (!url || typeof url !== 'string') return extraImage1;
        if (/^https?:\/\//.test(url)) {
            // 检查是否是Android设备，如果是则不使用代理
            const isAndroid = /Android/i.test(navigator.userAgent);
            if (isAndroid) {
                return url; // Android直接使用原URL
            }
            return url.replace(/^https?:\/\//, 'https://images.weserv.nl/?url=');
        }
        return url;
    }

    const handleImageLoad = (index) => {
        setLoadedImages(prev => new Set([...prev, index]));
    };

    const handleImageError = (index, e) => {
        const currentRetryCount = retryCount[index] || 0;
        console.log('图片加载失败:', index, e.target.src, '重试次数:', currentRetryCount);
        
        if (currentRetryCount < 2) {
            // 重试加载
            setTimeout(() => {
                const img = e.target;
                const originalSrc = img.src;
                img.src = '';
                img.src = originalSrc;
                setRetryCount(prev => ({
                    ...prev,
                    [index]: currentRetryCount + 1
                }));
            }, 1000);
        } else {
            // 重试失败，使用默认图片
            e.target.src = extraImage1;
        }
    };

    return (
        <div className={styles.ImgTxtList}>
            <ListView 
                hasMore={hasMore}
                onRefresh={onRefresh}
                loadMore={loadMore}
            >
                <div className={styles.body}>
                {
                    list.map((item, index)=> {
                        let extraImage = getImage(item.thumbUrl);
                        const updateTime = typeof item.articleUpdateTime === 'string'
                            ? item.articleUpdateTime?.substring(5, 16)
                            : '';
                        return <div className={styles.modalParagraph} key={index} onClick={() => {
                            //JsBridge.push('Web', { uri: item.url });
                            //
                        //    JsBridge.push('Web', { uri: item.url });
                            if(JsBridge.hasWebViewBridge()) {
                                JsBridge.push('Web', {uri: window.location.origin + `/front/guApp/kangyang/imgtxtdetail?url=${item.url}`});
                            }else {
                                history.push(`/front/guApp/kangyang/imgtxtdetail?url=${item.url}`)
                            }
                        }}>
                            <div className={styles.modalParagraphLeft}>
                                <div className={styles.leftTopText}>{item.title}</div>
                                <div className={styles.leftBottomText}>{item.source} {updateTime}</div>
                            </div>
                            <div className={styles.modalParagraphRight}>
                                <img 
                                    src={extraImage} 
                                    className={styles.rightImg} 
                                    alt={item.title} 
                                    loading="eager"
                                    onLoad={() => handleImageLoad(index)}
                                    onError={(e) => handleImageError(index, e)}
                                    style={{
                                        opacity: loadedImages.has(index) ? 1 : 0.7,
                                        transition: 'opacity 0.3s ease'
                                    }}
                                />
                            </div>
                        </div>
                    })
                }
                </div>
            </ListView>
            
            <Slogon />
        </div>
    )
}